import { render, staticRenderFns } from "./LoginStrategyLocal.vue?vue&type=template&id=2e9a5204&"
import script from "./LoginStrategyLocal.vue?vue&type=script&lang=js&"
export * from "./LoginStrategyLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports